/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
//剪切板

import VueClipboard from 'vue-clipboard2'
    
Vue.use(VueClipboard)


    // UI组件
import ElementUI from 'element-ui'
import { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)
    // 接口
import protocol from './assets/js/trans/protocol.js'
import protocolPt from './assets/js/trans/protocolPt.js'
import http from './assets/js/trans/http.js'
// import hqProtocol from './assets/js/hq/hqProtocol.js'
import protocolTrans from './assets/js/trans/protocolTrans.js'

import vueEsign from 'vue-esign'
Vue.use(vueEsign)

// import { hqWs } from './assets/js/hq/hqWs.js'
global.protocol = protocol
global.protocolPt = protocolPt

global.http = http
// global.hqProtocol = hqProtocol
// global.hqWs = hqWs
global.router = router
global.protocolTrans = protocolTrans
    // tool
import * as util from './assets/common/util.js'
global.util = util

import './directives'
import '@/assets/font/font.css'
//
// 引入filter
import vueFilter from './filters/filter'
// 遍历所有方法
Object.keys(vueFilter).forEach(key => {
        Vue.filter(key, vueFilter[key])
    })
    //全局回调函数
Vue.prototype.each = (arr, fn) => {
        for (var i = 0; i < arr.length; i++) {
            fn(arr[i])
        }
    }
    //判断并修改各种数据的值
Vue.prototype.modifyData = (arrIndex, arrProperty, judgeCondition, str, str2) => {
        if (arrIndex[arrProperty] == judgeCondition) { arrIndex[arrProperty] = str; } else { arrIndex[arrProperty] = str2 || arrIndex[arrProperty]; }
    }
    //判断并转换时间戳
Vue.prototype.modifyTime = (arrIndex, arrProperty, newProperty) => {
        if (newProperty) { arrIndex[newProperty] = Vue.prototype.DateFormate(Number(arrIndex[arrProperty])); return };
        arrIndex[arrProperty] = Vue.prototype.DateFormate(Number(arrIndex[arrProperty]));
    }
    //判断并添加数据
Vue.prototype.addObjData = (arrIndex, arrProperty, judgeCondition, str, str2, newProperty) => {
    if (arrIndex[arrProperty] == judgeCondition) { arrIndex[newProperty] = str; } else { arrIndex[newProperty] = str2 || arrIndex[arrProperty]; }
}

//判断数值是否是NaN
Vue.prototype.isNaNfn = (num, obj, pro) => {
        if (isNaN(num) == true) {
            obj[pro] = '0.00';
        } else { return obj[pro] = num; };
    }
    //小数点四舍五入
Vue.prototype.toFixedFn = (arrIndex, arrProperty, num, newProperty) => {
        if (newProperty) { arrIndex[newProperty] = Number(arrIndex[arrProperty]).toFixed(num); return };
        arrIndex[arrProperty] = Number(arrIndex[arrProperty]).toFixed(num);
    }
    //拷贝对象
Vue.prototype.copy = (obj) => {
        var newobj = {};
        for (var attr in obj) {
            newobj[attr] = obj[attr];
        }
        return newobj;
    }
    //精确小数点3位,不四舍五入
Vue.prototype.exactPointThree = (num, arrIndex, arrProperty) => {
    let newVal;
    num = Number(num);
    if (num < 0) {
        num = num.toString().substring(1);
        newVal = Number(num.toString().match(/^\d+(?:\.\d{0,3})?/)) * -1;
    } else {
        newVal = Number(num.toString().match(/^\d+(?:\.\d{0,3})?/));
    }
    //整数自动补0
    if (newVal.toString().indexOf(".") == -1) {
        newVal += '.000';
    }
    let len = newVal.toString().indexOf('.') + 1;
    //2位数自动补0
    if (newVal.toString().substring(len).split('').length == 2) {
        newVal += '0';
    }
    //1位数自动补0
    if (newVal.toString().substring(len).split('').length == 1) {
        newVal += '00';
    }
    if (arrProperty) {
        arrIndex[arrProperty] = newVal;
    }
    return newVal;
    // return Number(num.toString().match(/^\d+(?:\.\d{0,3})?/))
}

//精确小数点2位,不四舍五入
Vue.prototype.exactPointTwo = (num, arrIndex, arrProperty) => {
        let newVal;
        // if (arrProperty[arrProperty]=='--') {
        //   arrIndex[arrProperty] = num;
        //   return
        // // }
        // if(num=='--'){
        //   return '--'
        // }
        num = Number(num);
        if (num < 0) {
            num = num.toString().substring(1);
            newVal = Number(num.toString().match(/^\d+(?:\.\d{0,2})?/)) * -1;
        } else {
            newVal = Number(num.toString().match(/^\d+(?:\.\d{0,2})?/));
        }
        //整数自动补0
        if (newVal.toString().indexOf(".") == -1) {
            newVal += '.00';
        }
        let len = newVal.toString().indexOf('.') + 1;
        //1位数自动补0
        if (newVal.toString().substring(len).split('').length == 1) {
            newVal += '0';
        }
        if (arrProperty) {
            arrIndex[arrProperty] = newVal;
        }
        return newVal;
        // return Number(num.toString().match(/^\d+(?:\.\d{0,3})?/))
    }
    //精确小数点6位,不四舍五入
Vue.prototype.exactPointSix = (num, arrIndex, arrProperty) => {
    let newVal;

    num = Number(num);
    if (num < 0) {
        num = num.toString().substring(1);
        newVal = Number(num.toString().match(/^\d+(?:\.\d{0,6})?/)) * -1;
    } else {
        newVal = Number(num.toString().match(/^\d+(?:\.\d{0,6})?/));
    }
    //整数自动补0
    if (newVal.toString().indexOf(".") == -1) {
        newVal += '.000000';
    }
    let len = newVal.toString().indexOf('.') + 1;
    //1位数自动补0
    if (newVal.toString().substring(len).split('').length == 1) {
        newVal += '00000';
    }
    if (newVal.toString().substring(len).split('').length == 2) {
        newVal += '0000';
    }
    if (newVal.toString().substring(len).split('').length == 3) {
        newVal += '000';
    }
    if (newVal.toString().substring(len).split('').length == 4) {
        newVal += '00';
    }
    if (newVal.toString().substring(len).split('').length == 5) {
        newVal += '0';
    }
    if (arrProperty) {
        arrIndex[arrProperty] = newVal;
    }
    return newVal;
    // return Number(num.toString().match(/^\d+(?:\.\d{0,3})?/))
}
Vue.prototype.exactPointNon = (num, arrIndex, arrProperty) => {
        if (arrProperty) {
            arrIndex[arrProperty] = num;
        }
        return num;
    }
    //读取cookie
Vue.prototype.getCookie = (name) => {
        var arr,
            reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
        else return null;
    }
    //数组对象深拷贝
Vue.prototype.deepClone = (value) => {
        let type = typeof value;
        let newone = undefined;
        if (type === 'string' || type === 'number' || type === 'boolean') {
            newone = value;
        } else if (type === 'object') {
            if (value === null) {
                newone = null;
            } else if (Object.prototype.toString.call(value).slice(8, -1) === 'Object') {
                newone = {};
                for (let key of Object.keys(value)) {
                    newone[key] = Vue.prototype.deepClone(value[key]);
                }
            } else if (Object.prototype.toString.call(value).slice(8, -1) === 'Array') {
                newone = [];
                for (let i = 0; i < value.length; i++) {
                    newone.push(Vue.prototype.deepClone(value[i]))
                }
            }
        }
        return newone
    }
    //小数点后舍0,不四舍五入
Vue.prototype.automaticallyToZero = (num, arrIndex, arrProperty) => {
        let nIndex, aNumVal, bool;
        aNumVal = num.slice(num.indexOf('.') + 1).split('');
        //是否有小数点
        if (num.indexOf('.') == -1) {
            num;
        } else {
            //小数点后是否全为0;
            for (let i = 0; i < aNumVal.length; i++) {
                if (aNumVal[i] != 0) {
                    bool = true;
                    break;
                } else {
                    bool = false
                };
            }
            //全为0
            if (bool == false) {
                num = num.slice(0, num.indexOf("."));
            } else {
                //截取
                aNumVal = aNumVal.reverse();
                if (num.indexOf('.') != -1 && aNumVal.length > 0) {
                    for (let i = 0; i < aNumVal.length; i++) {
                        if (aNumVal[i] != "0") {
                            nIndex = i; //最后一位不为0数字的下标
                            break;
                        } else {
                            nIndex = 0;
                        }
                    }
                    num = num.substring(0, num.slice().length - nIndex);
                }
            }
        }
        if (arrProperty) {
            arrIndex[arrProperty] = num;
        }
        return num;
    }
    //数组去重
Vue.prototype.arrayNonRepeatfy = (arr) => {
        let hashMap = new Map();
        let result = new Array();
        for (let i = 0; i < arr.length; i++) {
            if (hashMap.has(arr[i])) {
                hashMap.set(arr[i], true);
            } else {
                hashMap.set(arr[i], false);
                result.push(arr[i]);
            }
        }
        return result;
    }
    //时间戳转换(具体)
Vue.prototype.DateFormate = (timer) => {
        // var timezone = 8; //目标时区时间，东八区
        // var offset_GMT = new Date().getTimezoneOffset();
        // var offset_GMT_Time = -offset_GMT/60;
        // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
        var newTimer = timer
        var date = new Date(newTimer);
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hour = date.getHours();
        var min = date.getMinutes();
        var sec = date.getSeconds();
        [year, month, day, hour, min, sec] = [year, month, day, hour, min, sec].map(item => item < 10 ? "0" + item : item);
        // return `${year}-${month}-${day} ${hour}:${min}:${sec}`;
        return `${year}-${month}-${day}  ${hour}:${min}:${sec}`;
    }
    //判断字段设置样式
Vue.prototype.setStrClass = (el, val, class1, class2) => el.indexOf(val) != -1 ? class1 : class2;
// 钩子函数,登录状态检查
router.beforeEach((to, from, next) => {
    if (to.meta.isIndex) {
        store.commit('changeIsIndex', true)
    } else {
        store.commit('changeIsIndex', false)
    }
    if (sessionStorage.getItem('sessionStr') && sessionStorage.getItem('userId')) {
        const userType = sessionStorage.getItem('userType')
        if (to.meta.requireAuth && userType == 'T') {
            // if (to.meta.requireAuth) {
            const highCerStatus = sessionStorage.getItem('highCerStatus')
            if (to.meta.highCerStatus && highCerStatus != '0') {
                Message({
                    showClose: true,
                    message: 'Please complete Verification and Senior Verification first',
                    type: 'error',
                    duration: 2000
                })
                next({
                    path: '/usercenter/highCertification'
                })
                return
            } else {
                next()
            }
            const nickNameStatus = sessionStorage.getItem('nickNameStatus')
            if (to.meta.nickNameStatus && nickNameStatus != '0') {
                next({
                    path: '/otcstart'
                })
            } else {
                next()
            }
        } else {
            next()
        }
    } else {
        if (to.meta.requireAuth) {
            next({
                path: '/login',
                query: {
                    redirect: (to.fullPath)
                } // 将跳转的路由path作为参数，登录成功后跳转到该路由
            })
        } else {
            next()
        }
    }
})

// //混入全局快捷键
// Vue.mixin({
//   data(){
//     return{
//       tq_onKeyCode_A:false,
//       tq_onKeyCode_Shift:false,
//       tq_onKeyCode_Ctrl:false,
//       tq_onKeyCode_Alt:false,
//       tq_onKeyCode_F1:false,
//       tq_onKeyCode_F2:false,
//       tq_onKeyCode_F3:false,
//       tq_onKeyCode_F4:false,
//     }
//   },
//   created(){
//     let _this = this
//     document.onkeydown = function(e){
//       let evn = e || event ;
//       let key = evn.keyCode || evn.which || evn.charCode ;
//       // A
//       if(key === 65){
//         _this.tq_onKeyCode_A = true ;
//       }
//       // Shift
//       if(key === 16){
//         _this.tq_onKeyCode_Shift = true;
//       }
//       // Ctrl
//       if(key === 17){
//         _this.tq_onKeyCode_Ctrl = true;
//       }
//       // Alt
//       if(key === 18){
//         _this.tq_onKeyCode_Alt = true;
//       }
//       // F1
//       if(key === 112){
//         _this.tq_onKeyCode_Alt = true;
//         _this.shortcuts_F1()
//       }
//       // F2
//       if(key === 113){
//         _this.tq_onKeyCode_Alt = true;
//         _this.shortcuts_F2()
//       }
//       // F3
//       if(key === 114){
//         _this.tq_onKeyCode_Alt = true;
//         _this.shortcuts_F3()
//       }
//       // F4
//       if(key === 115){
//         _this.tq_onKeyCode_Alt = true;
//         _this.shortcuts_F4()
//       }
//       // if(_this.tq_onKeyCode_Shift === true && _this.tq_onKeyCode_Ctrl === true && _this.tq_onKeyCode_A === true){
//       //   _this.tq_onKeyCode_Ctrl = false
//       //   _this.tq_onKeyCode_Shift = false
//       //   _this.tq_onKeyCode_A = false
//       //   _this.shortcuts_Ctrl_Shift_A()
//       // }
//     }
//     document.onkeyup = function(e){
//       if (e.keyCode === 65) {
//         _this.tq_onKeyCode_A = false
//       }
//       if (e.keyCode === 16) {
//         _this.tq_onKeyCode_Shift = false
//       }
//       if (e.keyCode === 17) {
//         _this.tq_onKeyCode_Ctrl = false
//       }
//       if (e.keyCode === 18) {
//         _this.tq_onKeyCode_Alt = false
//       }
//       if (e.keyCode === 112) {
//         _this.tq_onKeyCode_F1 = false
//       }
//       if (e.keyCode === 113) {
//         _this.tq_onKeyCode_F2 = false
//       }
//       if (e.keyCode === 114) {
//         _this.tq_onKeyCode_F3 = false
//       }
//       if (e.keyCode === 115) {
//         _this.tq_onKeyCode_F4 = false
//       }
//     }
//   },
//   methods:{
//     shortcuts_Ctrl_Shift_A(event){
//       // if(event.keyCode==16){
//       //   alert('shift')
//       // }
//       alert('Ctrl+Shift+A');
//     },
//     shortcuts_F1(event){
//       // this.$refs.trade_input_buy_quality.focus()
//     },
//     shortcuts_F2(event){
//       // this.$refs.trade_input_buy_amount.focus()
//     },
//     shortcuts_F3(event){
//       // this.$refs.trade_input_sell_quality.focus()
//     },
//     shortcuts_F4(event){
//       // this.$refs.trade_input_sell_amount.focus()
//     },

//   },
// })

import BaseApi from './assets/baseServe/baseServe'
global.BaseApi = BaseApi

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')